// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-DecoratedImage----styles-module---container---6hpzT","decoration":"src-components-DecoratedImage----styles-module---decoration---EkBS-","image":"src-components-DecoratedImage----styles-module---image---1u5t3","imageWrapper":"src-components-DecoratedImage----styles-module---imageWrapper---3_MXX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DecoratedImage/styles.module.css
// module id = 498
// module chunks = 168707334958949